module.exports = __webpack_public_path__ + "img/login.5ebb3930.svg";